"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterOptionsDto = exports.CardSlotDto = exports.ProblematicSlotDto = exports.DraftTimeSlotDto = exports.TimeSlotConflictsDto = exports.UpdateSlotsColorsDto = exports.SlotsIdsDto = exports.TimeSlotsDto = exports.TimeSlotDto = exports.DraftSlotDto = exports.DraftSlotsDto = exports.UpdateDraftSlotDto = exports.BaseDraftSlotDto = exports.SlotRowDto = exports.SlotDto = exports.BaseSlotDto = exports.BaseSlotFieldsDto = exports.SlotProductPricesMetadataDto = exports.SlotProductMetadataDto = void 0;
const organization_dto_1 = require("../../organization/dto/organization.dto");
const reservation_enums_1 = require("../types/enums/reservation.enums");
class SlotProductMetadataDto {
}
exports.SlotProductMetadataDto = SlotProductMetadataDto;
class SlotProductPricesMetadataDto {
}
exports.SlotProductPricesMetadataDto = SlotProductPricesMetadataDto;
class BaseSlotFieldsDto {
}
exports.BaseSlotFieldsDto = BaseSlotFieldsDto;
class BaseSlotDto extends BaseSlotFieldsDto {
}
exports.BaseSlotDto = BaseSlotDto;
class SlotDto extends BaseSlotDto {
}
exports.SlotDto = SlotDto;
class SlotRowDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.SlotRowDto = SlotRowDto;
class BaseDraftSlotDto extends BaseSlotDto {
}
exports.BaseDraftSlotDto = BaseDraftSlotDto;
class UpdateDraftSlotDto {
}
exports.UpdateDraftSlotDto = UpdateDraftSlotDto;
class DraftSlotsDto extends BaseSlotFieldsDto {
}
exports.DraftSlotsDto = DraftSlotsDto;
class DraftSlotDto extends BaseDraftSlotDto {
}
exports.DraftSlotDto = DraftSlotDto;
class TimeSlotDto {
}
exports.TimeSlotDto = TimeSlotDto;
class TimeSlotsDto {
}
exports.TimeSlotsDto = TimeSlotsDto;
class SlotsIdsDto {
}
exports.SlotsIdsDto = SlotsIdsDto;
class UpdateSlotsColorsDto {
}
exports.UpdateSlotsColorsDto = UpdateSlotsColorsDto;
class TimeSlotConflictsDto {
}
exports.TimeSlotConflictsDto = TimeSlotConflictsDto;
class DraftTimeSlotDto {
}
exports.DraftTimeSlotDto = DraftTimeSlotDto;
class ProblematicSlotDto {
}
exports.ProblematicSlotDto = ProblematicSlotDto;
class CardSlotDto extends SlotDto {
}
exports.CardSlotDto = CardSlotDto;
class FilterOptionsDto {
}
exports.FilterOptionsDto = FilterOptionsDto;
reservation_enums_1.SlotFilterOptions.SEGMENTS, reservation_enums_1.SlotFilterOptions.ACTIVITIES, reservation_enums_1.SlotFilterOptions.FACILITIES, reservation_enums_1.SlotFilterOptions.INSTRUCTORS, reservation_enums_1.SlotFilterOptions.ADDONS, reservation_enums_1.SlotFilterOptions.PRODUCTS, reservation_enums_1.SlotFilterOptions.INVOICES, reservation_enums_1.SlotFilterOptions.SPACES, reservation_enums_1.SlotFilterOptions.APPROVAL_STATUS, reservation_enums_1.SlotFilterOptions.PAYMENT_STATUS, reservation_enums_1.SlotFilterOptions.MAINTENANCE;
//# sourceMappingURL=slot.dto.js.map